import React from 'react';
import { Link } from 'react-router-dom';
import LumaCalendarEmbed from '../components/LumaCalendarEmbed';

const Events = () => (
  <div className="min-h-screen bg-cream" data-testid="events-page">
    {/* Hero */}
    <section className="bg-cream pt-28 sm:pt-32 md:pt-36 pb-12 md:pb-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-5">
          <span className="text-dark-green/40">&rarr;</span> Dharma Initiative &middot; Events
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-tight tracking-tight mb-8 max-w-6xl">
          <span className="text-gradient-hero">Hosting extraordinary</span>
          <br />
          <span className="text-gradient-hero-light italic">people.</span>
        </h1>
        <p className="text-dark-green/75 text-lg sm:text-xl md:text-2xl leading-snug max-w-3xl">
          Space-specific events and community flagships, hosted at some of the best places across London.
        </p>
      </div>
    </section>

    {/* Live Luma calendar */}
    <section className="bg-cream py-14 sm:py-18 md:py-22 px-4 sm:px-6 border-t border-dark-green/10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14 grid md:grid-cols-12 gap-4 md:gap-8 items-end">
          <div className="md:col-span-7">
            <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-3">
              <span className="text-dark-green/40">&rarr;</span> 01 / Programme
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-dark-green leading-tight">
              Upcoming events for DI.
            </h2>
            <p className="text-dark-green/70 text-base md:text-lg leading-relaxed mt-3 max-w-xl">
              Most events are limited to our Mentees and Mentors.
            </p>
          </div>
          <p className="md:col-span-5 text-dark-green/60 text-sm md:text-base font-mono uppercase tracking-tight md:text-right">
            Live calendar &middot; powered by Luma
          </p>
        </div>

        <div
          className="overflow-hidden rounded-xl border border-dark-green/10"
          data-testid="luma-calendar-embed"
        >
          <LumaCalendarEmbed
            src="https://luma.com/embed/calendar/cal-mF9xjWpop2pt4ZW/events"
            title="Dharma Initiative Events Calendar"
          />
        </div>

        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row sm:items-center gap-4">
          <p className="text-dark-green/60 font-mono text-xs uppercase tracking-tight">
            Want a heads-up on the next one?
          </p>
          <Link
            to="/apply"
            className="inline-flex items-center gap-2 bg-dark-green text-cream px-6 py-3 rounded-full text-base font-medium hover:bg-dark-green/90 transition-all duration-300 group"
          >
            Join the network
            <span aria-hidden className="group-hover:translate-x-1 transition-transform">&rarr;</span>
          </Link>
          <a
            href="https://luma.com/user/usr-u1oQ7VFH1JQcbDw"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-dark-green/30 text-dark-green px-6 py-3 rounded-full text-base font-medium hover:border-dark-green transition-all duration-300 sm:ml-auto"
          >
            Open in Luma
            <span aria-hidden>&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  </div>
);

export default Events;
